<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <Loader v-if="loading"></Loader>
        <div class="d-flex justify-content-center align-items-center vh-100" v-else>
          <div class="user-cta">
            <Icon name="geLogin" width="36" class="mb-3"/>
            <div class="mb-5">
              <h4 class="user-cta__title">{{ $t('sso.title') }}</h4>
              <h5 class="user-cta__subtitle">{{subtitle}}</h5>
            </div>
            <b-button class="user-cta__action" variant="primary" @click="doLogin" target="_blank">
              {{ $t('sso.btn_login') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapActions} from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  name: 'SingleSignOn',
  components: {Loader},
  data() {
    return {
      loading: false
    }
  },
  async mounted() {

  },
  computed: {
    subtitle() {
      if (!this.$route.query.t) return ''
      const token = this.jwtDecode(this.$route.query.t)
      return this.$t('sso.subtitle', {email: token.payload.email})
    }
  },
  methods: {
    ...mapActions('auth', [
      'ssoLogin',
      'getCurrentUser'
    ]),
    async doLogin() {
      this.loading = true
      if (this.$route.query.t && this.$route.query.k) {
        console.log('SSO login')
        this.$store.commit('SET_IS_PREVIEW_CHECKIN', true)
        try {
          const response = await this.ssoLogin({
            token: this.$route.query.t,
            integration_id: this.$route.query.k,
          })
          await this.getCurrentUser()
          if (response.picacode) {
            sessionStorage.setItem('picacode', response.picacode)
            await this.$router.push({name: 'checkins-list'})
          } else
            await this.$router.push({name: 'checkins-list'})
        } catch (error) {
          await this.$router.push({name: 'homepage'})
        }
      }
    },
    jwtDecode(t) {
      let token = {};
      token.raw = t;
      token.header = JSON.parse(window.atob(t.split('.')[0]));
      token.payload = JSON.parse(window.atob(t.split('.')[1]));
      return token;
    }
  }
}
</script>
<style>
  .site-banner {
    display: none !important;
  }
</style>